module.exports = __webpack_public_path__ + "img/limit-c.2b5aaf8.svg";